import * as React from 'react';

import { shouldShowPriceSlider } from 'utils/price-filter-utils';

import { CheckboxGroup } from 'components/common/search-form/fields/checkbox-group';
import { SearchFormFieldProps } from 'components/common/search-form';
import { Slider } from 'components/common/search-form/fields/slider';

export const Price: React.FunctionComponent<SearchFormFieldProps> = props => {
  const { modelKey, sortAndFilterOptions } = props;
  const priceFilterOption = sortAndFilterOptions && sortAndFilterOptions[modelKey];

  if (!priceFilterOption) {
    return null;
  }

  const { min, max } = sortAndFilterOptions && sortAndFilterOptions[modelKey];

  return shouldShowPriceSlider(min, max) ? <Slider {...props} /> : <CheckboxGroup {...props} />;
};
